"use client";

import { AppHeader } from "@/components/layout/AppHeader";
import { BottomNav } from "@/components/layout/BottomNav";
import { LeftNav } from "@/components/layout/nav/LeftNav";
import { RightNav } from "@/components/layout/nav/RightNav";
import { BiomeProvider } from "@/context/BiomeProvider";
import { CheckoutProvider } from "@/context/CheckoutProvider";
import { Erc20Provider } from "@/context/Erc20Provider";
import { LoginModalProvider } from "@/context/LoginModalContext";
import { OnboardingStepProvider } from "@/context/OnboardingStepProvider/OnboardingStepProvider";
import { RightNavProvider } from "@/context/RightNavContext";
import { useOnboardingModal } from "@/hooks/useOnboardingModal";
import { DevRevProvider } from "../DevRevProvider";
import Footer from "../Footer";
import { OnboardingModal } from "../Onboarding/components/OnboardingModal";
import { WeeklyRewardsProvider } from "../WeeklyRewards/WeeklyRewardsProvider";

interface AppShellProps {
  disableContainerPadding?: boolean;
  hideRightNav?: boolean;
  children: React.ReactNode;
}

export function AppShell({
  children,
  disableContainerPadding,
  hideRightNav,
}: AppShellProps) {
  const {
    isModalOpen,
    setIsModalOpen,
    isOnboardingModalEnabled,
    triggerOnboarding,
  } = useOnboardingModal();

  return (
    <BiomeProvider>
      <LoginModalProvider>
        <DevRevProvider>
          <WeeklyRewardsProvider>
            <Erc20Provider>
              <CheckoutProvider>
                <RightNavProvider>
                  <div
                    id="app-shell"
                    className="min-h-screen text-white bg-black/40"
                  >
                    <div className="flex">
                      <LeftNav />

                      <main className="flex flex-col overflow-x-hidden flex-grow">
                        {/* Hide the header on the game page */}
                        {hideRightNav ? null : (
                          <AppHeader signInCallback={triggerOnboarding} />
                        )}

                        {isOnboardingModalEnabled ? (
                          <OnboardingStepProvider
                            isModal
                            closeModal={() => setIsModalOpen(false)}
                          >
                            <OnboardingModal
                              isModalOpen={isModalOpen}
                              setIsModalOpen={setIsModalOpen}
                            />
                          </OnboardingStepProvider>
                        ) : null}

                        <div
                          className={`flex-1 flex flex-col ${disableContainerPadding ? "" : "p-6"} ${hideRightNav ? "" : "pb-20 md:pb-6"}`}
                        >
                          <div className="flex-1">{children}</div>
                          {hideRightNav ? null : <Footer />}
                        </div>
                      </main>

                      {hideRightNav ? null : (
                        <RightNav signInCallback={triggerOnboarding} />
                      )}
                    </div>

                    <BottomNav />
                  </div>
                </RightNavProvider>
              </CheckoutProvider>
            </Erc20Provider>
          </WeeklyRewardsProvider>
        </DevRevProvider>
      </LoginModalProvider>
    </BiomeProvider>
  );
}
